module.exports = __webpack_public_path__ + "static/media/08_genderless.28d2d03e.jpg";